import { useQuery } from 'react-query'

import { QUERY_KEYS } from '../../api'
import { ContractsApi } from './api'
import { ContractsFilterResponse } from '../../types'

interface UseContractsFiltersOutput {
  contractsFilters: ContractsFilterResponse | undefined
  contractsFiltersIsLoading: boolean
}

const useContractsFilters = (filters: any): UseContractsFiltersOutput => {
  const { data: contractsFilters, isLoading: contractsFiltersIsLoading } = useQuery(
    [QUERY_KEYS.CONTRACTS_FILTERS, filters?.carrierId, filters?.asnum],
    () =>
      ContractsApi.getContractsFilter({
        filters: { carrierId: filters?.carrierId, asnum: filters?.asnum },
      }),
  )

  return { contractsFilters, contractsFiltersIsLoading }
}
export default useContractsFilters
